<template>
  <div class="sg-order-track">
    <div class="bg-10px"></div>
    <div class="cell-con">
      <div class="cell"><div class="left">订单编号:</div><div class="right">{{ $route.query.jdOrderId }}</div></div>
      <div class="cell"><div class="left">国内承运人:</div><div class="right">{{ waybillCode.carrier }}</div></div>
    </div>
    <div class="bg-10px"></div>
    <div class="track-list-con">
      <div class="list" v-for="(item, i) in orderTrack" :key="i">
        <div class="left"></div>
        <div class="right">
          <div class="text">{{ item.content }}</div>
          <div class="time">{{ item.msgTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getJDOrderTrack } from '@/api/mall/mallJD'
export default {
  data(){
    return {
      orderTrack: [],//物流信息
      waybillCode: {},//物流信息
    }
  },
  created(){
    if(this.$route.query.jdOrderId){
      this.getJDOrderTrack(this.$route.query.jdOrderId)
    }
  },
  methods: {
    //  获取物流配送信息
    getJDOrderTrack(jdOrderId){
      getJDOrderTrack({jdOrderId,waybillCode: 1}).then(res=>{
        if(res.code===200){
          this.orderTrack = res.data.orderTrack.reverse() || []
          this.waybillCode = res.data.waybillCode[0] || {}
          console.log(this.orderTrack, this.waybillCode)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.sg-order-track{
  .cell-con{
    padding: 10px 12px;
    .cell{
      display: flex;align-items: center;font-size: 12px;line-height: 1;padding: 5px 0;color: rgb(51,51,51);
      .left{
        width: 70px;
      }
      .right{
        flex: 1;font-weight: bold;
      }
    }
  }
  .track-list-con{
    padding: 12px;
    .list{
      font-size: 12px;color: rgb(153,153,153);
      padding: 10px 0;position: relative;
      .left{
        position: absolute;top: 0;bottom: 0;width: 1px;background-color: #d5d5d5;
        &:before{
          position: absolute;top: 16px;left: -2px;width: 5px;height: 5px;border-radius: 50%;
          background-color: #d5d5d5;content: '';
        }
      }
      .right{
        padding-left: 20px;
        .text{line-height: 20px;}
        .time{}
      }
      &:first-child{
        .left{
          top: 16px;
          &:before{
            background-color: #f74646;top: 0;
          }
        }
        .right{
          .text{color: rgb(51,51,51);}
          .time{color: rgb(102,102,102);}
        }
      }
      &:last-child{
        .left{
          bottom: auto;height: 16px;
        }
      }
    }
  }
}
</style>